import React from "react";
import Icon from "../Icon";
import "./index.scss";
import PropTypes from "prop-types";

const CardTemplate = ({ item, onClick }) => {
  return (
    <div style={{
      width: !window.location.pathname.includes('login') ? '214px' : ''
    }} className="card" role="presentation" onClick={onClick}>
      <div className="card__top">
        <div className="card__icon">
          <Icon name={item.icon} />
          {/* {
            item.newIcon &&  <span className="new__icon">New</span>
          } */}
        </div>
        {item.new && <span className="card__new">New</span>}
      </div>
      <div className="card__bottom">
        <div className="card__title">{item.title}</div>
        <div className="card__description">{item.description}</div>
      </div>
    </div>
  );
};

CardTemplate.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
};

export default CardTemplate;
